import React from 'react'
// import Modal from '../../modal/Modal'
// import { Bounce, toast } from 'react-toastify'
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import Checkout from './checkout';
// import { getStatusById } from '../../utlis/utlis'
// import './paypal.css';

// s
export default function PayPal(props: any) {
  const { payload,callAfterPayment} = props
  console.log(payload?.clientId)

  // const { providerOrderId } = payload
  // const [showModal, setShowModal] = useState(true)
  // const [loader, setLoader] = useState(false)
  // const [timeLeft, setTimeLeft] = useState(120) // 2 minutes in seconds
  // const [timerActive, setTimerActive] = useState(false)
  // const [apiStatus, setApiStatus] = useState('')
  const initialOptions = {
    "client-id": payload?.clientId,
    currency: "USD",
    intent: "capture",
  };

  // useEffect(() => {
  //   // showPayPal()
  // }, [])
  // useEffect(() => {
  //   let timer: any
  //   let interval: any

  //   if (timerActive) {
  //     // Start the countdown timer
  //     timer = setInterval(() => {
  //       setTimeLeft((prevTime) => {
  //         if (prevTime <= 1) {
  //           clearInterval(timer)
  //           clearInterval(interval)
  //           setTimerActive(false)
  //           callAfterPayment()

  //           return 0 // Stop timer at 0
  //         }
  //         return prevTime - 1
  //       })
  //     }, 1000)

  //     // Make API calls every 2 minutes
  //     interval = setInterval(() => {
  //       // fetchApiData()
  //       console.log('')
  //     }, 2000) // 120000 ms = 2 minutes

  //     // Cleanup function
  //     return () => {
  //       clearInterval(timer)
  //       clearInterval(interval)
  //     }
  //   }

    // Cleanup if timer is not active
  //   return () => {
  //     clearInterval(timer)
  //     clearInterval(interval)
  //   }
  // }, [timerActive])
  // const fetchApiData = async () => {
  //   try {
  //     const response = await getStatusById(pe_txnId, headers)
  //     console.log(response?.data?.result?.status)
  //     if (response?.status) {
  //       // Check if the status is success or failure and stop the timer
  //       if (response?.data?.result?.status === 'SUCCESS' || response?.data?.result?.status === 'FAILED') {
  //         setTimerActive(false)
  //         callAfterPayment()
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error fetching API data:', error)
  //     setTimerActive(false)
  //     callAfterPayment()
  //   }
  //   // callAfterPayment(true)
  // }

  // const startTimer = () => {
  //   setApiStatus('')
  //   setTimeLeft(120)
  //   setTimerActive(true)
  //   console.log(apiStatus)
  // }

  // async function showPayPal() {
  //   const res = await loadScript(`https://www.paypal.com/sdk/js?client-id=${payload?.clientSecret}`)
  //   if (!res) {
  //     // alert("PayPal SDK failed to load. Are you online?");
  //     toast.error('PayPal SDK failed to load. Are you online?', {
  //       position: 'top-right',
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: 'light',
  //       transition: Bounce,
  //     })
  //     return
  //   }
  //   // @ts-ignore
  //   window.paypal
  //     .Buttons({
  //       // @ts-ignore
  //       createOrder: async (data: any, actions: any) => {
  //         console.log({ data })
  //         console.log({ actions })

  //         try {
  //           if (!providerOrderId) {
  //             throw new Error('Provider Order ID not found.')
  //           }
  //           return providerOrderId
  //         } catch (error) {
  //           console.error('Error creating PayPal order:', error)
  //           // transactionStatusCallback(error)
  //           throw error
  //         }
  //       },

  //       onError: (err: any) => {
  //         console.error('Error in PayPal payment:', err)

  //         callAfterPayment(false)

  //         setShowModal(false)
  //       },
  //       //@ts-ignore
  //       onApprove: function (data: any, actions: any) {
  //         return actions.order.capture().then(function (details: any) {
  //           console.log({ details })
  //           localStorage.setItem('details', details)
  //           setLoader(true)
  //           startTimer()
  //           //         callAfterPayment(true)

  //           setShowModal(false)
  //         })
  //       },
  //       //@ts-ignore
  //       onError: function (err: any) {
  //         console.error('PayPal error:', err)
  //         toast.error('An error occurred during the payment process. Please try again later.', {
  //           position: 'top-right',
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: 'light',
  //           transition: Bounce,
  //         })
  //         // alert('An error occurred during the payment process. Please try again later.');
  //         callAfterPayment(false)
  //       },
  //     })
  //     .render('#paypal-button-container')
  // }

  // const handleHideModal = () => {
  //   callAfterPayment(false)

  //   // setShowModal(false)
  // }

//   return showModal ? (
//     <Modal title={'Complete Payment'} onHide={handleHideModal}>
//       <div id='paypal-button-container'></div>
//     </Modal>
//   ) : (
//     <div>
//       {loader && (
//         <div className='loader-container'>
//           <div className='loader'></div>
//           <p className='fetching-message'>
//             Time Left: {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, '0')}
//           </p>
//         </div>
//       )}
//     </div>
//   )

return <>
<PayPalScriptProvider options={initialOptions}>
        <Checkout payload={payload} callAfterPayment={callAfterPayment}/>
</PayPalScriptProvider>
</>
}





